<template lang="pug">
  ul.ods-kpi__list.ods-kpi--default
    li.ods-kpi__number
      div.kpi_circle
        span ---
        span.symbol {{ symbol }}
    li.kpi_title
      span {{ $t(unit) }} {{ $t(type) }}
    li.kpi_null
      span ---
</template>

<script>

export default {
  name: 'KpiDefault',
  data () {
    return {
    }
  },
  props: {
    symbol: {
      type: String
    },
    unit: {
      type: String
    },
    type: {
      type: String
    }
  }
}
</script>

<style scoped lang="scss">

  .ods-kpi{
    &__list{
      min-height: rem(64);
      width: 100%;
    }
    &__number{
      font-family: Soho;
      font-size: rem(32);
      line-height: 1;
      font-weight: 500;
      &+.kpi_title{
        margin: rem(8) 0;
        color: $--color--grey-medium;
      }
      .symbol{
        font-family: Soho;
        font-size: rem(18);
        line-height: 1;
        font-weight: 600;
      }
    }
  }
  .kpi_title{
    font-family: Soho;
    font-size: rem(9);
    line-height: 1;
    letter-spacing: .8px;
    font-weight: 500;
    text-transform: uppercase;
  }
  .kpi_circle{
    height: auto;
    line-height: rem(16);
    margin-bottom: rem(10);
    & > span{
      display: inline-block;
      line-height: 1;
      word-break: break-word;
      margin: 0;
      &:first-child{
        margin-right: 3px;
      }
    }
  }
  .kpi_null {
    font-family: Soho;
    font-size: rem(11);
    line-height: 1;
    letter-spacing: .4px;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/components/KpiDefault.vue